export default class EntityMenuItemKind {
	static INTERNAL_LINK = 'INTERNAL_LINK';
	static EXTERNAL_LINK = 'EXTERNAL_LINK';
	static FOLDER = 'FOLDER';
}
